//@flow
import * as React from 'react';
import Settings from 'config/Settings'
import {applyCarColorCode} from 'utils/vrUtils'

const SessionStateContext: Object = React.createContext(null);
const SessionDispatchContext: Object = React.createContext(null);

export type StateType = {
  skipGuide: Array<string>,
  carIndex: number,
  selectedColorIndices: Array<number>,
}
type ActionType = 
  | {type: 'SKIP_GUIDE', data: string}
  | {type: 'SELECT_CAR', data: number}
  | {type: 'SELECT_EXTERIOR_COLOR', data: number}
  | {type: 'APPLY_EXTERIOR_COLOR', data: null}
;
function sessionReducer(state: StateType, action: ActionType) {
  console.log('session', action, state)
  switch (action.type) {
    case 'SKIP_GUIDE':
      let skipGuideList = state.skipGuide?.slice() ?? []
      skipGuideList.push(action.data);
      return {...state, skipGuide: skipGuideList};
    case 'SELECT_CAR':
      console.assert(action.data >= 0 && action.data < Settings.model.length);
      if (action.data >= 0 && action.data < Settings.model.length) {

        const colorCode = getExteriorColorCode(state.selectedColorIndices, action.data);
        console.warn("will apply color code", colorCode);
        applyCarColorCode(colorCode);
        return {...state, carIndex: action.data};
      }
      return state;
    case 'SELECT_EXTERIOR_COLOR':
      let list = state.selectedColorIndices.slice();
      console.assert(action.data >= 0 && action.data < Settings.colorCodes[state.carIndex].length);
      if (list[state.carIndex] !== action.data) {
        list[state.carIndex] = action.data;
        const colorCode = getExteriorColorCode(list, state.carIndex);
        console.warn("will apply color code(1)", colorCode);
        applyCarColorCode(colorCode);
        return {...state, selectedColorIndices: list};
      }
      return state;
    case 'APPLY_EXTERIOR_COLOR': 
      const colorCode = getExteriorColorCode(state.selectedColorIndices, state.carIndex);
      console.warn("will apply color code(2)", colorCode);
      applyCarColorCode(colorCode);
      return state;
    default:
      return state;
  }
}

function sessionInit() {
  const exteriorColors = Settings.model.map((model, index) => Settings.colorCodes[index].indexOf(Settings.defaultColorCode[index]));

  return {
    skipGuide: [],
    carIndex: 0,
    selectedColorIndices: exteriorColors
  } 
}

type Props = {
  children: React.Node
}

export default function Session(props: Props): React.Element<any> {
  const [state, dispatch] = React.useReducer(sessionReducer, {}, sessionInit);
  return (
    <SessionStateContext.Provider value={state}>
      <SessionDispatchContext.Provider value={dispatch}>
          {props.children}
      </SessionDispatchContext.Provider>
    </SessionStateContext.Provider>
  );
}

export function useSessionState(): StateType {
  const state = React.useContext(SessionStateContext);
  if (!state) {
    throw new Error('Cannot find SessionProvider');
  }
  return state;
}

export function useSessionDispatch(): (ActionType) => void {
  const dispatch = React.useContext(SessionDispatchContext);
  if (!dispatch) {
    throw new Error('Cannot find SessionProvider');
  }
  return dispatch;
}

export function useExteriorColorIndex(): number {
  const sessionState = useSessionState();
  return getExteriorColorIndex(sessionState.selectedColorIndices, sessionState.carIndex);
}

export function useExteriorColorCode(): string {
  const sessionState = useSessionState();
  return getExteriorColorCode(sessionState.selectedColorIndices, sessionState.carIndex);
}

export function getExteriorColorIndex(selectedColorIndices: Array<number>, carIndex: number): number {
  if (carIndex >= 0 && carIndex < selectedColorIndices.length) {
    return selectedColorIndices[carIndex];
  }
  return -1;
}

export function getExteriorColorCode(selectedColorIndices: Array<number>, carIndex: number): string {
  const index = getExteriorColorIndex(selectedColorIndices, carIndex);
  return index >= 0 && index < Settings.colorCodes[carIndex].length ? Settings.colorCodes[carIndex][index] : "";
}
